import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeEnGb from '@angular/common/locales/en-GB';
import localeEs from '@angular/common/locales/es';
import localeFi from '@angular/common/locales/fi';
import localeFr from '@angular/common/locales/fr';
import localeIt from '@angular/common/locales/it';
import localePt from '@angular/common/locales/pt';
import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

registerLocaleData(localeDe, 'de');
registerLocaleData(localeEnGb, 'en-GB');
registerLocaleData(localeEs, 'es');
registerLocaleData(localeFi, 'fi');
registerLocaleData(localeFr, 'fr');
registerLocaleData(localeIt, 'it');
registerLocaleData(localePt, 'pt');

// Keep in sync with TinyHelper.countryCodeToLocale.
const ANGULAR_LOCALES: Record<string, string> = {
    de: 'de',
    en: 'en-GB',
    es: 'es',
    fi: 'fi',
    fr: 'fr',
    it: 'it',
    pt: 'pt'
};

// Angular reads LOCALE_ID as a string, so this follows the language selected in the app at read time.
@Injectable()
export class AppLocaleId extends String {
    private readonly translateService = inject(TranslateService);

    public constructor() {
        super();
    }

    public override toString(): string {
        const language = (this.translateService.currentLang() || 'en').toLowerCase().split('-')[0];
        return ANGULAR_LOCALES[language] ?? ANGULAR_LOCALES['de'];
    }

    public override valueOf(): string {
        return this.toString();
    }

    public override toLowerCase(): string {
        return this.toString().toLowerCase();
    }
}
